import typography from '../typography';

const MuiChip = {
  root: {
    ...typography.body2,
    borderRadius: '22px',
    minWidth: '133px',
    height: '44px',
  }
};

export default MuiChip;
